module.exports = __webpack_public_path__ + "static/qrph-banner-82467e8983bd07b8a94fba773d2b609e.jpg";